import { useEffect, useState } from "react";
import Toast from "@/components/_shared/Toast";
import InputSection from "@/components/umformulieren/InputSection";
import OutputSection from "@/components/umformulieren/OutputSection";
import { usePageSettings } from "@/lib/cookies";

const defaultSettings = {
	defaultMode: "customer", // technical | customer | neutral
	defaultTone: "neutral", // neutral | formal | casual
	defaultTextLength: "normal", // short | normal | long
	darkMode: true,
};

export default function ParaphraseForm() {
	const [inputText, setInputText] = useState("");
	const [outputText, setOutputText] = useState("");
	const [isGenerating, setIsGenerating] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [copySuccess, setCopySuccess] = useState(false);
	const [successMessage, setSuccessMessage] = useState<string | null>(null);
	const [toastType, setToastType] = useState<"success" | "error">("success");

	// Settings aus Cookie laden
	const { settings, updateSettings } = usePageSettings(
		"umformulieren",
		defaultSettings,
	);

	const handleToast = (msg: { type: "success" | "error"; message: string }) => {
		setToastType(msg.type);
		setSuccessMessage(msg.message);
	};

	useEffect(() => {
		if (successMessage) {
			const timer = setTimeout(() => setSuccessMessage(null), 3000);
			return () => clearTimeout(timer);
		}
	}, [successMessage]);

	return (
		<>
			<Toast
				message={successMessage || ""}
				onClose={() => setSuccessMessage(null)}
				type={toastType}
				visible={!!successMessage}
			/>

			<div className="card rounded-xl border border-gray-100 p-6 shadow-sm backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800/70">
				<h2 className="mb-4 border-gray-100 border-b pb-2 font-semibold text-gray-800 text-xl dark:border-gray-700 dark:text-gray-100">
					Satz umformulieren
				</h2>

				<InputSection
					inputText={inputText}
					isGenerating={isGenerating}
					mode={settings.defaultMode}
					onToast={handleToast}
					setError={setError}
					setInputText={setInputText}
					setIsGenerating={setIsGenerating}
					setMode={(v: "technical" | "customer" | "neutral") =>
						updateSettings({ defaultMode: v })
					}
					setOutputText={setOutputText}
					setTextLength={(v: "short" | "normal" | "long") =>
						updateSettings({ defaultTextLength: v })
					}
					setTone={(v: "neutral" | "formal" | "casual") =>
						updateSettings({ defaultTone: v })
					}
					textLength={settings.defaultTextLength}
					tone={settings.defaultTone}
				/>
			</div>

			<OutputSection
				copySuccess={copySuccess}
				error={error}
				outputText={outputText}
				setCopySuccess={setCopySuccess}
			/>
		</>
	);
}
